import { gql } from '@apollo/client';

/**
 * A moderator's decision on reported content.
 * APPROVED puts it back exactly as it was; REMOVED hides it from the app entirely.
 */
export const SET_CONTENT_REVIEW_STATUS = gql`
    mutation SetContentReviewStatus($contentType: String!, $contentId: Int!, $reviewStatus: String!) {
        setContentReviewStatus(contentType: $contentType, contentId: $contentId, reviewStatus: $reviewStatus) {
            success
            reviewStatus
        }
    }
`;
